<template>
  <form
    v-if="isPermittedAll([
      'UsersGetAll'
    ])"
    id="search-form"
    @submit.prevent="searchUsers">
    <v-container class="px-5">
      <!-- Hidden -->
      <v-row
        v-if="isPermittedAll([
          'UsersViewDeleted'
        ])">
        <v-col class="pt-0">
          <h3 class="mb-3">Filter</h3>
          <label for="search-users-include-hidden">Hidden:</label>
          <Autocomplete
            id="search-users-include-hidden"
            :items="$store.state.hiddenStatuses"
            v-model="hiddenStatusSearchParameter"
            outlined
            filled>
          </Autocomplete>
        </v-col>
      </v-row>
      <!-- / Hidden -->

      <!-- Search -->
      <v-row>
        <v-col>
          <v-btn
            type="submit"
            color="success"
            outlined
            block
            :disabled="$store.getters.isLoadingActive">
            Search Users
          </v-btn>
        </v-col>
      </v-row>
      <!-- / Search -->
    </v-container>
  </form>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'UsersSearchForm',
  computed: {
    userSearchParameters() {
      return this.$store.state.userSearchParameters;
    },
    hiddenStatusSearchParameter: {
      get() {
        let hiddenStatus = _.find(
          this.$store.state.hiddenStatuses,
          { value: this.userSearchParameters.HiddenStatus },
        );

        if (!hiddenStatus) {
          hiddenStatus = {
            value: undefined,
            text: this.anyOption,
          };
        }

        return hiddenStatus;
      },
      set(hiddenStatusSearchParameter) {
        const params = {
          HiddenStatus: hiddenStatusSearchParameter.value || undefined,
        };

        this.$store.commit(
          'setSearchParameters',
          { paramsKey: 'userSearchParameters', params },
        );
      },
    },
  },
  methods: {
    searchUsers() {
      this.$store.dispatch('getUsers');
    },
  },
};
</script>

<style lang="scss"></style>
